import './js/bootstrap';

import './js/components/nav';

import './style.scss';

import { navController } from './js/components/nav';

navController();
